import { jsxs as y, Fragment as E, jsx as s } from "react/jsx-runtime";
import { FileSelectorModal as v } from "@systemeio/file-manager";
import { useEditorState as x } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as M, useEffect as F } from "react";
import { twJoin as d } from "tailwind-merge";
import { LinkBubbleEdit as B, LinkBubbleView as w } from "./link-bubble-state.mjs";
import { BubbleMenu as O } from "../../components/bubble-menu/BubbleMenu.mjs";
const z = ({ editor: e, fileSource: f, options: l }) => {
  const r = x({
    editor: e,
    selector: ({ editor: n }) => ({
      href: n == null ? void 0 : n.getAttributes("link").href
    })
  }), t = r == null ? void 0 : r.href, [S, a] = M(!1), [u, i] = M(!1);
  F(() => {
    a(!t);
  }, [t]);
  const L = () => e == null ? void 0 : e.chain().focus().extendMarkRange("link").unsetLink().setMeta("addToHistory", !1).run(), m = (n) => {
    e && (a(!1), e.chain().focus().extendMarkRange("link").setLink({ href: n }).run());
  }, o = () => {
    if (!e) return;
    const n = e.state.schema.marks.link;
    if (!n) return;
    const { tr: c } = e.state;
    let h = !1;
    e.state.doc.descendants((k, p) => {
      k.marks.some((b) => b.type === n && !b.attrs.href) && (c.removeMark(p, p + k.nodeSize, n), h = !0);
    }), h && (c.setMeta("addToHistory", !1), e.view.dispatch(c));
  }, g = () => {
    a(!1), o();
  };
  return !e || !(e != null && e.options.editable) ? null : /* @__PURE__ */ y(E, { children: [
    /* @__PURE__ */ s(
      O,
      {
        className: d(u && "hidden"),
        editor: e,
        pluginKey: "linkBubbleMenu",
        options: {
          onHide: g
        },
        shouldShow: ({ editor: n }) => n.isActive("link"),
        children: /* @__PURE__ */ s("form", { onSubmit: (n) => n.preventDefault(), className: "flex items-center p-2", children: S ? /* @__PURE__ */ s(
          B,
          {
            initialValue: t ?? "",
            onSaveLink: m,
            openFileSelector: () => {
              e.commands.blur(), i(!0);
            },
            schemeOptions: l == null ? void 0 : l.schemeOptions
          }
        ) : /* @__PURE__ */ s(w, { href: t ?? "", unsetLink: L, setIsEditing: a }) })
      }
    ),
    /* @__PURE__ */ s(
      v,
      {
        uploadingFromSource: f,
        initialSearchFilters: {
          source: [f],
          name: "",
          type: []
        },
        opened: u,
        onClose: () => {
          i(!1), o();
        },
        onSelect: (n) => {
          m(n.path), i(!1);
        }
      }
    )
  ] });
};
export {
  z as LinkBubbleMenu
};
